<template>
  <div>
    <validated-form
      name="chargeToRoom"
      :disabled="isProcessing"
      @valid-submit="submit"
    >
      <div class="section section--half-y-padding">
        <button
          class="link link--has-title"
          type="button"
          tabindex="-1"
          @click="$closeModal('chargeToRoom')"
        >
          <div class="layout layout--icon layout--icon-extra-spacing">
            <span class="icon icon--smedium far fa-arrow-left dark-gray" />
            <h2 class="title title--2">
              Charge To Room
            </h2>
          </div>
        </button>
      </div>

      <div class="section section--half-y-padding">
        <h3 class="title title--6">
          Room Info
        </h3>

        <p>Please use the last name on the room reservation & your room number.</p>

        <text-input
          v-model="roomLastName"
          type="text"
          label="Last Name"
          name="roomLastName"
          icon-class="fa-user-circle"
          :validations="{
            required: true
          }"
        />

        <text-input
          v-model="roomNumber"
          type="text"
          label="Room Number"
          name="roomNumber"
          icon-class="fa-door-closed"
          :validations="{
            required: true
          }"
        />
      </div>

      <contact-information
        v-if="!hideContactInfo"
        v-model="contactInfo"
        class="section section--half-y-padding"
        :email-input-state="emailInputState"
        :phone-is-required="phoneIsRequired || session.smsReceiptOptIn"
      />

      <sms-receipt-opt-in
        v-if="!hideSms"
        class="section section--half-y-padding"
      />

      <div class="section section--half-y-padding section--alt-background section--shadow">
        <div class="layout layout--horizontal layout--horizontal-equal">
          <div v-if="showTotal">
            <p class="smaller dark-gray no-spacing">
              Your Total
            </p>

            <p class="title title--3 bold no-wrap">
              <b>{{ $dollars(total) }}</b>
            </p>
          </div>

          <button
            class="button button--primary button--large button--auto-width"
            :class="{
              'button--loading': isProcessing
            }"
            type="submit"
          >
            {{ payCtaText }}
          </button>
        </div>
      </div>
    </validated-form>
  </div>
</template>



<script>
  import ContactInformation from './contact-information.vue';
  import { mapGetters } from 'vuex';


  export const validateEmailInputState = value => [
    'required',
    'optional',
    'hidden'
  ].includes(value);


  export default {
    name: 'ChargeToRoom',

    components: {
      ContactInformation
    },

    props: {
      emailInputState: {
        type: String,
        default: 'required',
        validator: validateEmailInputState
      },
      hideContactInfo: {
        type: Boolean,
        default: false
      },
      hideSms: {
        type: Boolean,
        default: false
      },
      payCtaText: {
        type: String,
        default: 'Pay'
      },
      phoneIsRequired: {
        type: Boolean,
        default: false
      },
      roomNumberAutofill: {
        type: String,
        default: null
      },
      showTotal: {
        type: Boolean,
        default: true
      },
      total: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        contactInfo: {},
        isProcessing: false,
        roomLastName: null,
        roomNumber: null
      };
    },

    computed: {
      ...mapGetters('giftCards', ['giftCards']),
      ...mapGetters('session', ['session'])
    },

    watch: {
      isProcessing: 'isProcessingChangeHandler'
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (this.roomNumberAutofill) {
          this.roomNumber = this.roomNumberAutofill;
        }
      },

      isProcessingChangeHandler(isProcessing) {
        if (isProcessing) {
          this.$lockModal('chargeToRoom');
        }

        else {
          this.$unlockModal('chargeToRoom');
        }
      },

      onCheckoutError() {
        this.isProcessing = false;
        this.$closeModal('chargeToRoom');
        this.$closeModal('paymentInformation');
      },

      onCheckoutSuccess() {
        this.$closeModal('chargeToRoom');
        this.$closeModal('paymentInformation');
      },

      submit() {
        this.isProcessing = true;

        this.$emit('checkout', {
          contactInfo: this.contactInfo,
          onCheckoutError: this.onCheckoutError,
          onCheckoutSuccess: this.onCheckoutSuccess,
          paymentMethod: {
            type: 'room-charge',
            roomLastName: this.roomLastName,
            roomNumber: this.roomNumber,
            giftCards: this.giftCards.appliedCards
          }
        });
      }
    }
  };
</script>
